module.exports = __webpack_public_path__ + "img/image-03.6a8f0e83.jpg";